import React from 'react';
import PropTypes from 'prop-types';

function FormCheckbox({
  checked = false, dark = false, id, label, name, onChange, required = false, value,
}) {
  return (
    <div className={`c-form-checkbox ${dark ? 'c-form-checkbox--dark' : ''}`}>
      <input
        checked={checked}
        className="c-form-checkbox__input"
        id={id}
        name={name}
        onChange={() => {}}
        type="checkbox"
        required={required}
        value={value}
      />

      <label
        aria-checked={value}
        className="c-form-checkbox__label"
        htmlFor={id}
        onClick={() => onChange(name)}
        onKeyDown={() => onChange(name)}
        role="checkbox"
        tabIndex={0}
      >
        {label}
      </label>
    </div>
  );
}

FormCheckbox.propTypes = {
  checked: PropTypes.bool,
  dark: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
};

export default FormCheckbox;
